module.exports = __webpack_public_path__ + "static/media/questions.ee6ac050.jpeg";